import { takeLatest } from 'redux-saga/effects';
import { checkService } from './checkService';
import {
  SELECT_PUBLISH_TERMS_SERVICE,
  LOAD_PUBLISH_TERMS_SUCCESS,
  SELECT_PLACING_TYPE,
  SELECT_PLACING_PERIOD,
  SELECT_PACKAGE,
  CHANGE_AUTO_PROLONG,
  CHANGE_AUCTION_BET,
  REVERT_AUCTION_BET,
  CLEAR_AUCTION_BET,
  SET_CALLTRACKING_ENABLED,
} from '../../reducers';

export function* checkoutInfoSagas() {
  yield takeLatest(
    [
      SELECT_PUBLISH_TERMS_SERVICE,
      LOAD_PUBLISH_TERMS_SUCCESS,
      SELECT_PLACING_TYPE,
      SELECT_PLACING_PERIOD,
      SELECT_PACKAGE,
      CHANGE_AUTO_PROLONG,
      CHANGE_AUCTION_BET,
      REVERT_AUCTION_BET,
      CLEAR_AUCTION_BET,
      SET_CALLTRACKING_ENABLED,
    ],
    checkService,
  );
}
